import { z } from "zod";

export const MAX_NAME_LENGTH = 100;
export const MAX_LABEL_LENGTH = 100;
export const MAX_MESSAGE_LENGTH = 2000;

export const nameSchema = z
  .string()
  .trim()
  .min(1, { message: "Name must not be empty." })
  .max(MAX_NAME_LENGTH, {
    message: `Name must be ${MAX_NAME_LENGTH} characters or fewer.`,
  });

export const labelSchema = z
  .string()
  .trim()
  .min(1, { message: "Label must not be empty." })
  .max(MAX_LABEL_LENGTH, {
    message: `Label must be ${MAX_LABEL_LENGTH} characters or fewer.`,
  });

export const messageSchema = z
  .string()
  .trim()
  .min(1, { message: "Message must not be empty." })
  .max(MAX_MESSAGE_LENGTH, {
    message: `Message must be ${MAX_MESSAGE_LENGTH} characters or fewer.`,
  });

export const emailSchema = z.email({
  message: "Please enter a valid email address.",
});

export const MIN_PASSWORD_LENGTH = 10;
export const MAX_PASSWORD_LENGTH = 128;

export const passwordSchema = z
  .string()
  .min(MIN_PASSWORD_LENGTH, {
    message: `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`,
  })
  .max(MAX_PASSWORD_LENGTH, {
    message: `Password must be ${MAX_PASSWORD_LENGTH} characters or fewer.`,
  })
  .refine((val) => !/^\s+$/.test(val), {
    message: "Password must not be only whitespace.",
  });
